import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {GetServerSideProps} from 'next'
import {useEffect, useState, useRef, ReactEventHandler, use} from 'react'
//@ts-ignore
import {useLottie} from '@/hooks/useLottie'
import classNames from 'classnames'
import {useActivity} from '@/pages/activity/tenyears'
import {CombineImage_Map, IMAGE_MAP, Lottie_Map, TenAcTitle} from '@/constants/activityCdn'
import TitleBar from '@/components/TitleBar'
import {Toast} from 'gotu-ui'
import {DoMissionRes, FragmentModule, MainButton, SubActivityModule, winnerItem} from '@/service/activity'
import {useUaParam} from '@/pages/_app'
import {openWindow} from '@/plugins/bridge'
const styles = require('./style.module.less')
interface CakeBoxProps {
  leave: boolean,
  rewardInfo: DoMissionRes | null,
  fragmentModule: FragmentModule,
  winerList?: winnerItem[],
  mainButton: MainButton,
}
const cakeImgList = [
    {
        url: CombineImage_Map.cake_1,
        zIndex: 9,
        hide: true,
        first: true,
    },
    {
        url: CombineImage_Map.cake_2,
        zIndex: 10,
        hide: true,
        first: true,
    },
    {
        url: CombineImage_Map.cake_3,
        zIndex: 9,
        hide: true,
        first: true,
    },
    {
        url: CombineImage_Map.cake_4,
        zIndex: 8,
        hide: true,
        first: true,
    },
    {
        url: CombineImage_Map.cake_5,
        zIndex: 6,
        hide: true,
        first: true,
    },
    {
        url: CombineImage_Map.cake_6,
        zIndex: 7,
        hide: true,
        first: true,
    },
]
const CakeBox = (props: CakeBoxProps) => {
    const {
        leave,
        rewardInfo,
        fragmentModule,
        winerList,
        mainButton,
    } = props

    const [cakeList, setCakeList] = useState<any[]>([])
    const [activeCake, setActiveCake] = useState(0)
    const swiper = useRef<any>(null)
    const {isApp, visualCenterPosition = 0} = useUaParam()
    const lottieRef = useRef<any>(null)
    const starRef = useRef<any>(null)
    const guideRef = useRef<any>(null)
    const flowerRef = useRef<any>(null)
    const [firstGuide, setFirstGuide] = useState(false)
    const [userList, setUserList] = useState<winnerItem[][]>([])
    const countRef = useRef(-1)
    const [cakeAnimation, setCakeAnimation] = useState(false)
    const [options, setOptions] = useState({
        loop: false,
        autoplay: false,
        path: Lottie_Map.cake,
        direction: 1,
        speed: 1,
    } as any)
    const [anim, loadFinish] = useLottie(
        lottieRef,
        options,
    )
    const [optionsStar, setOptionsStar] = useState({
        loop: false,
        autoplay: false,
        path: Lottie_Map.star,
        direction: 1,
        speed: 1,
    } as any)
    const [animStar, loadFinishStar, loadLottie, animStarRef] = useLottie(
        starRef,
        optionsStar,
    )
    const [optionsGuide, setOptionsGuide] = useState({
        loop: false,
        autoplay: false,
        path: Lottie_Map.gudie,
        direction: 1,
        speed: 1,
    } as any)
    const [animGuide, loadFinishGuide, loadLottieGuide, animGuideRef] = useLottie(
        guideRef,
        optionsGuide,
    )
    const [optionsFlower, setOptionsFlower] = useState({
        loop: false,
        autoplay: false,
        path: Lottie_Map.flower,
        direction: 1,
        speed: 1,
    } as any)
    const [animFlower, loadFinishFlower, loadLottieFlower, animFlowerRef] = useLottie(
        flowerRef,
        optionsFlower,
    )
    const {fragmentList} = fragmentModule
    useEffect(() => {
        if (fragmentList.length > 0) {
            let count = 0
            let t1: any = null
            let t2: any = null
            let t3:any = null
            fragmentList.forEach((item) => {
                if (item.count > 0) {
                    count++
                }
            })
            setActiveCake(count)
            // 合成蛋糕后 ，蛋糕全部展示
            if (mainButton.status === 4) {
                cakeImgList.forEach((item) => {
                    item.hide = false
                    item.first = true
                })
                setCakeList(cakeImgList)
                // 触发星星动画，由于触发的时机问题，animStar直接获取不到，改为animStarRef
                t2 = setTimeout(() => {
                    animStarRef.current?.goToAndPlay(0, false)
                    animFlowerRef.current?.goToAndPlay(0, false)
                    clearTimeout(t2)
                }, 600)
            } else {
                let newCount = count
                setCakeList(cakeImgList.map((item) => {
                    return {...item, hide: !(newCount-- > 0)}
                }))
                // 后续蛋糕下落动画，仅下落最新获取的蛋糕
                cakeImgList.forEach((item, i) => {
                    item.first = (count > i)
                })
                // 碎片种类增加时，触发下层蛋糕动画 ， 初次不触发该动画
                if (countRef.current !== count && countRef.current !== -1) {
                    t1 = setTimeout(() => {
                        anim?.goToAndPlay(0, false)
                        clearTimeout(t1)
                    }, 500)
                    t3 = setTimeout(() => {
                        setCakeAnimation(true)
                        clearTimeout(t3)
                        setTimeout(() => {
                            setCakeAnimation(false)
                        }, 750)
                    }, 750)
                }
            }
            countRef.current = count
            return () => {
                t1 && clearTimeout(t1)
                t2 && clearTimeout(t2)
                t3 && clearTimeout(t3)
            }
        }
    }, [fragmentList, mainButton])
    useEffect(() => {
        // 将winerList拆分为两部分
        if (winerList && winerList.length > 0) {
            let list1: winnerItem[] = []
            let list2: winnerItem[] = []
            winerList.forEach((item, i) => {
                if (i % 2 === 0) {
                    list1.push(item)
                } else {
                    list2.push(item)
                }
            })
            setUserList([list1, list2])
        }
    }, [winerList])
    useEffect(() => {
        if (localStorage.getItem('_cakeGuideForTen') === '1') {
            return
        }
        // 接口未返回数据不触发引导动画
        if (fragmentList.length === 0) return
        if (fragmentList.length > 0) {
            let count = 0
            fragmentList.forEach((item) => {
                if (item.count > 0) {
                    count++
                }
            })
            if (count > 0) { // 存在碎片时，不触发引导动画
                return
            }
            setFirstGuide(true)
            if (loadFinishGuide) {
                animGuideRef.current?.goToAndPlay(0, false)
                localStorage.setItem('_cakeGuideForTen', '1')
                setTimeout(() => {
                    setFirstGuide(false)
                    // animGuideRef.current?.goToAndStop(0, false)
                }, 5000)
            }
        }
    }, [loadFinishGuide, fragmentList])
    const changeCake = () => {
        if (activeCake > 6) {
            setActiveCake(0)
            return
        }
        setActiveCake(activeCake + 1)
    }
    return (
        <div className={classNames(styles.cakes,)}>
            <div
                className={classNames(leave && 'hide')}
                onClick={changeCake}
            >
                <div className={classNames(firstGuide && 'opacity0')}>
                    {
                        cakeList.map((item, index) => {
                            return (
                                <img
                                    className={classNames({
                                        [styles['small-cake']]: true,
                                        [styles['active-cake']]: (!item.hide && !item.first),
                                        [styles.hide]: item.hide,
                                        [styles['active-cake-2']]: (!item.hide && item.first && cakeAnimation),
                                    })}
                                    style={{zIndex: item.zIndex}}
                                    key={index}
                                    src={item.url}
                                    width={162}
                                    height={103}
                                ></img>
                            )
                        })
                    }
                </div>
                <div
                    className={classNames(styles.lottie, firstGuide && styles.hide)}
                    ref={lottieRef}
                ></div>
                <div
                    className={classNames(styles.star, mainButton.status === 4 && styles.active, firstGuide && styles.hide)}
                    ref={starRef}
                ></div>
                <div
                    className={classNames(styles.flower, mainButton.status === 4 && styles.active, firstGuide && styles.hide)}
                    ref={flowerRef}
                ></div>
                <div
                    ref={guideRef}
                    className={classNames(styles.guide, !firstGuide && 'hide')}
                ></div>
                <img
                    className={styles['gift-car']}
                    src={CombineImage_Map.gift_car}
                    width={180}
                    height={234}
                ></img>
                <img
                    className={styles['gift-gold']}
                    src={CombineImage_Map.gift_gold}
                    width={183}
                    height={183}
                ></img>
                <img
                    className={styles['gift-camera']}
                    src={CombineImage_Map.gift_camera}
                    width={180}
                    height={234}
                ></img>
                <img
                    className={styles['gift-pad']}
                    src={CombineImage_Map.gift_pad}
                    width={180}
                    height={234}
                ></img>
                <img
                    className={styles['gift-card']}
                    src={CombineImage_Map.gift_card}
                    width={180}
                    height={234}
                ></img>
            </div>
            {
                (rewardInfo && userList.length > 0) && (
                    <div className={styles['user-box']}>
                        {
                            userList.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className='f'
                                    >
                                        <div
                                            className={classNames(index === 0 ? styles.line1 : styles.line1)}
                                            style={{animationDuration: `${item.length * 3}s`}}
                                        >
                                            {
                                                item.map((item, index) => {
                                                    return (
                                                        <UserBox
                                                            key={index}
                                                            item={item}
                                                        ></UserBox>
                                                    )
                                                })
                                            }
                                        </div>

                                    </div>
                                )
                            })

                        }

                        {/* <div className={styles.line2}>
                            {
                                userList2.map((item, index) => {
                                    return (
                                        <UserBox
                                            key={index}
                                            item={item}
                                        ></UserBox>
                                    )
                                })
                            }
                        </div> */}
                    </div>
                )
            }
            {
                rewardInfo && (
                    <div className={styles.reward}>
                        <div className='por w100%'>
                            <I
                                className='w100% hauto'
                                width={200}
                                height={200}
                                src={rewardInfo?.rewardInfo.rewardImgUrl || 'https://i.gsxcdn.com/2429295616_o1j3bg5e.png'}
                            >
                            </I>
                            <div className='poa b-12% w100% tcenter'>
                                <div className={classNames(styles.title)}>恭喜获得</div>
                                <div className={styles.title}>{rewardInfo?.congratulationText}</div>
                            </div>
                        </div>
                        <div className={styles.des}>{ rewardInfo?.description}</div>
                    </div>
                )
            }
        </div>
    )
}

export default CakeBox

const UserBox = (props:any) => {
    const {item} = props
    return (
        <div
            className={styles.user}
        >
            <I
                className={styles.avatar}
                src={item.userIcon}
                width={18}
                height={18}
            ></I>
            <span className='ml6'>{item.name}</span>
            <span className='ml6'>
                获得
                {item.rewardName}
            </span>
        </div>
    )
}
